import { memo } from "react";
import {
    convertDateToUKFormat,
    formatMoney,
    truncateText
} from "../../utils";

const TableRow = ({ job, onRowClick }) => {

    const {
        job_id,
        job_is_pay_ftm,
        job_postcode,
        job_createdAt,
        ftm,
        customer,
        sub_skill,
        financial,
        discount
    } = job;

    // ---- Safe Values ----
    const labour = Number(financial?.job_financial_total_labour) ?? 0;
    const labourCommission = Number(financial?.job_financial_total_labour_commission) ?? 0;
    const materials = Number(financial?.job_financial_total_materials_fee) ?? 0;
    const materialsCommission = Number(financial?.job_financial_company_commission_materials_fee) ?? 0;

    // ---- Total Before Discount ----
    const total = labour + labourCommission + materials + materialsCommission;

    // ---- Discount Calculation ----
    let discountAmount = 0;

    if (discount) {
        if (discount?.job_discount_type === 1) {
            // percentage
            discountAmount = (total * (discount?.job_discount_value ?? 0)) / 100;
        } else {
            // fixed amount
            discountAmount = discount?.job_discount_value ?? 0;
        }
    }

    const finalTotal = total - discountAmount;

    return (
        <tr
            className={`hover-row ${job_is_pay_ftm === 0 ? "row-highlight" : ""}`}
            onClick={() => onRowClick(ftm.ftm_id)}
            style={{ cursor: "pointer" }}
        >
            {/* Job Ref */}
            <td className="align-middle">
                <span className="text-secondary text-sm font-weight-bold">
                    #{job_id}
                </span>
            </td>

            {/* Tradesperson */}
            <td>
                <div className="d-flex px-2 py-1">
                    <img
                        src={ftm?.ftm_profile_image_path}
                        className="avatar avatar-sm me-3"
                        alt="tradesperson"
                    />

                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">
                            {ftm?.ftm_forename} {ftm?.ftm_surname}
                        </h6>

                        <span className="text-xs text-secondary">
                            {ftm?.ftm_vehicle_number}
                        </span>
                    </div>
                </div>
            </td>

            {/* Customer */}
            <td>
                <div className="d-flex px-2 py-1">
                    <img
                        src={customer?.customer_profile_image}
                        className="avatar avatar-sm me-3"
                        alt="customer"
                    />

                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">
                            {customer?.customer_full_name}
                        </h6>

                        <span className="text-xs text-secondary">
                            {customer?.customer_email}
                        </span>
                    </div>
                </div>
            </td>

            {/* Postcode */}
            <td className="align-middle text-center">
                <span className="text-secondary text-sm font-weight-bold">
                    {job_postcode ?? "N/A"}
                </span>
            </td>

            {/* Service Category */}
            <td>
                <div className="d-flex px-2 py-1">
                    <div className="pe-2 d-flex align-items-center justify-content-center">
                        <i
                            className="material-icons text-success"
                            style={{ fontSize: 30 }}
                        >
                            {sub_skill?.skill?.skill_web_app_icon}
                        </i>
                    </div>

                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">
                            {truncateText(sub_skill?.sub_skill_name, 20)}
                        </h6>

                        <span className="text-xs text-secondary">
                            {sub_skill?.skill?.skill_name}
                        </span>
                    </div>
                </div>
            </td>

            {/* Created */}
            <td className="align-middle text-center text-sm font-weight-bold">
                {convertDateToUKFormat(job_createdAt)}
            </td>

            {/* Working Hours */}
            <td className="align-middle text-center text-sm font-weight-bold">
                {financial?.job_financial_billable_work_hours ?? 0} hrs
            </td>

            {/* Labour */}
            <td className="align-middle text-center text-sm font-weight-bold">
                {formatMoney(labour)}
            </td>

            {/* Labour Commission */}
            <td className="align-middle text-center text-sm font-weight-bold">
                {formatMoney(labourCommission)}
            </td>

            {/* Materials */}
            <td className="align-middle text-center text-sm font-weight-bold">
                {formatMoney(materials)}
            </td>

            {/* Materials Commission */}
            <td className="align-middle text-center text-sm font-weight-bold">
                {formatMoney(materialsCommission)}
            </td>

            {/* Discount */}
            <td className="align-middle text-center text-sm font-weight-bold text-danger">
                {formatMoney(discountAmount)}
            </td>

            {/* Total */}
            <td className="align-middle text-center text-sm font-weight-bold text-success">
                {formatMoney(finalTotal)}
            </td>
        </tr>
    );
};

export default memo(TableRow);